import { usePaldockTranslation } from "hooks/usePaldockTranslation";
import { useCallback } from "react";

// BE step type → translation key (resolved against "components.connection-creator")
const STEP_TYPE_TO_KEY: Record<string, string> = {
    http: "nodes.http.title",
    delay: "nodes.wait.title",
    set: "nodes.set.title",
    modify: "nodes.modify.title",
    breaker: "nodes.breaker.title",
    webhook: "nodes.webhook.title",
    success: "nodes.end.title",
    integration: "nodes.start.title",
    outgoing_postback: "nodes.start.title",
    incoming_postback: "nodes.start.title",
    structure: "nodes.start.title",
};

// Types that get a suffix: "Start - Integration", "Start - Outgoing Postback", "Start - Incoming Postback"
const STEP_TYPE_SUFFIX_KEY: Record<string, string> = {
    integration: "enums.entity_types.integration",
    outgoing_postback: "enums.entity_types.tracking_out",
    incoming_postback: "enums.entity_types.tracking_in",
    structure: "enums.entity_types.form_structure",
};

/**
 * Returns a function that translates a BE step type to a human-readable label.
 * Reusable in both select options and table column renders.
 */
export const useStepTypeLabel = () => {
    const { t } = usePaldockTranslation("components.connection-creator");

    return useCallback(
        (type: string): string => {
            let label = STEP_TYPE_TO_KEY[type] ? t(STEP_TYPE_TO_KEY[type]) : type;
            if (STEP_TYPE_SUFFIX_KEY[type]) {
                label = `${label} - ${t(STEP_TYPE_SUFFIX_KEY[type])}`;
            }
            return label;
        },
        [t]
    );
};
